import { FC } from 'react';
import { ThemeColor } from 'styles';
import { StyledButton, ButtonColor } from './styled';

type Props = {
  children: any;
  id?: string;
  submit?: boolean;
  disabled?: boolean;
  onClick?: (e: any) => void;
  color?: ThemeColor;
  backgroundColor?: ButtonColor;
  marginRight?: boolean;
};

const Button: FC<Props> = ({
  children,
  id,
  submit,
  onClick,
  color = 'onPrimary',
  backgroundColor = 'primaryDark',
  disabled = false,
  marginRight = false,
}) => {
  return (
    <StyledButton
      id={id}
      onClick={onClick}
      className={backgroundColor}
      type={submit ? 'submit' : 'button'}
      $backgroundColor={backgroundColor}
      $marginRight={marginRight}
      disabled={disabled}
      color={color}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
